export var smsCodeInputFieldNames = [
    'firstCodeNumber',
    'secondCodeNumber',
    'thirdCodeNumber',
    'forthCodeNumber',
    'fifthCodeNumber',
    'sixthCodeNumber',
    'seventhCodeNumber',
];
